
<template>
  <div class="app-shell">
    <div class="container body-content" id="app">
      <app-header v-bind:title="header"></app-header>
      <router-view></router-view>
    </div>
    <app-footer v-bind:title="footer"></app-footer>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "App",
  components: {
    "app-header": Header,
    "app-footer": Footer,
  },

  data() {
    return {
      header: "Apps Catalog",
      footer: " © Copyright 2021-2026 HP Apps Catalog",
    };
  },
};
</script>

<style lang="scss">
.app-shell {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
#app {
  flex: 1 0 auto;
  text-align: right;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background-color: $hpPageBackground;
  padding-top: 10px;
  position: relative;
  z-index: 2;
}
</style>
